import { useState } from 'react';
import { labelRentang, labelTanggal, slugKategori, rapikanSetDicuci } from '../lib/setDicuci';

const TABS = [
  { v: 'kat', l: 'Per kategori' },
  { v: 'hari', l: 'Per hari' },
  { v: 'minggu', l: 'Per minggu' },
];

export function SetDicuci({ data, judulPeriode }) {
  const [tab, setTab] = useState('kat');
  const sd = rapikanSetDicuci(data);
  const maks = Math.max(1, ...sd.per_kategori.map((x) => x.set), sd.bawahan_saja);
  const th = 'text-[10px] uppercase tracking-wider text-mocha font-semibold px-2 py-2 border-b border-border';
  const td = 'px-2 py-2.5 border-b border-border/60';

  return (
    <div className="bg-white rounded-2xl border border-border shadow-soft p-5" data-testid="set-dicuci-card">
      <h2 className="font-display text-xl text-ink mb-1">Set Dicuci</h2>
      <p className="text-xs text-mocha mb-3" data-testid="set-dicuci-ket">
        {judulPeriode} · dihitung dari tanggal barang kembali
      </p>

      <div className="inline-flex rounded-xl border border-border overflow-hidden mb-3" role="tablist">
        {TABS.map((t) => (
          <button
            key={t.v}
            role="tab"
            aria-selected={tab === t.v}
            data-testid={`set-dicuci-tab-${t.v}`}
            onClick={() => setTab(t.v)}
            className={`px-4 py-1.5 text-xs font-semibold transition-colors ${tab === t.v ? 'bg-brown text-white' : 'bg-white text-mocha hover:bg-ivory'}`}
          >
            {t.l}
          </button>
        ))}
      </div>

      {tab === 'kat' && (
        <table className="w-full text-sm" data-testid="set-dicuci-tabel-kat">
          <thead>
            <tr>
              <th className={`${th} text-left`}>Kategori</th>
              <th className={`${th} hidden sm:table-cell`} />
              <th className={`${th} text-right`}>Set</th>
            </tr>
          </thead>
          <tbody>
            {sd.per_kategori.map((x) => (
              <tr key={x.kategori} data-testid={`set-dicuci-row-${slugKategori(x.kategori)}`}>
                <td className={td}>{x.kategori}</td>
                <td className={`${td} hidden sm:table-cell w-2/5`}>
                  <div className="h-2 rounded bg-gold/20"><div className="h-2 rounded bg-brown" style={{ width: `${(x.set / maks) * 100}%` }} /></div>
                </td>
                <td className={`${td} text-right font-semibold`} data-testid={`set-dicuci-nilai-${slugKategori(x.kategori)}`}>{x.set}</td>
              </tr>
            ))}
            <tr data-testid="set-dicuci-row-bawahan-saja">
              <td className={td}>
                Bawahan saja <span className="ml-1 text-[10px] bg-gold/15 text-gold-dark border border-gold/30 rounded-full px-2 py-0.5">tanpa atasan</span>
              </td>
              <td className={`${td} hidden sm:table-cell`}>
                <div className="h-2 rounded bg-gold/20"><div className="h-2 rounded bg-brown" style={{ width: `${(sd.bawahan_saja / maks) * 100}%` }} /></div>
              </td>
              <td className={`${td} text-right font-semibold`} data-testid="set-dicuci-nilai-bawahan-saja">{sd.bawahan_saja}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr className="bg-choco text-white" data-testid="set-dicuci-footer">
              <td className="px-3 py-2.5 rounded-l-xl font-bold text-xs tracking-wide">TOTAL SET DICUCI</td>
              <td className="hidden sm:table-cell" />
              <td className="px-3 py-2.5 rounded-r-xl text-right font-display text-lg" data-testid="set-dicuci-footer-total">{sd.total}</td>
            </tr>
          </tfoot>
        </table>
      )}

      {tab === 'hari' && (
        <table className="w-full text-sm" data-testid="set-dicuci-tabel-hari">
          <thead><tr><th className={`${th} text-left`}>Tanggal kembali</th><th className={`${th} text-right`}>Set</th></tr></thead>
          <tbody>
            {sd.per_hari.length === 0 && <tr><td colSpan={2} className={`${td} text-center text-mocha`}>Belum ada barang kembali pada periode ini.</td></tr>}
            {sd.per_hari.map((x) => (
              <tr key={x.date} data-testid={`set-dicuci-hari-${x.date}`}>
                <td className={td}>{labelTanggal(x.date)}</td>
                <td className={`${td} text-right font-semibold`}>{x.set}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="bg-choco text-white"><td className="px-3 py-2.5 rounded-l-xl font-bold text-xs tracking-wide">TOTAL</td><td className="px-3 py-2.5 rounded-r-xl text-right font-display text-lg" data-testid="set-dicuci-hari-total">{sd.total}</td></tr>
          </tfoot>
        </table>
      )}

      {tab === 'minggu' && (
        <table className="w-full text-sm" data-testid="set-dicuci-tabel-minggu">
          <thead><tr><th className={`${th} text-left`}>Minggu (Senin – Minggu)</th><th className={`${th} text-right`}>Set</th></tr></thead>
          <tbody>
            {sd.per_minggu.length === 0 && <tr><td colSpan={2} className={`${td} text-center text-mocha`}>Belum ada barang kembali pada periode ini.</td></tr>}
            {sd.per_minggu.map((x) => (
              <tr key={x.start} data-testid={`set-dicuci-minggu-${x.start}`}>
                <td className={td}>{labelRentang(x.start, x.end)}</td>
                <td className={`${td} text-right font-semibold`}>{x.set}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="bg-choco text-white"><td className="px-3 py-2.5 rounded-l-xl font-bold text-xs tracking-wide">TOTAL</td><td className="px-3 py-2.5 rounded-r-xl text-right font-display text-lg" data-testid="set-dicuci-minggu-total">{sd.total}</td></tr>
          </tfoot>
        </table>
      )}

      <div className="mt-4 text-[11.5px] text-mocha leading-relaxed" data-testid="set-dicuci-aturan">
        <p><b className="text-ink">Cara hitung:</b> 1 set = 1 setelan atasan (Kebaya, Baju Bodo, Jas Tutup, Dress, Kemeja/Batik Pria). Bawahan dan jilbab bawaan ikut di dalamnya. Bawahan yang disewa sendiri dihitung 1 set.</p>
        <p>Tidak dihitung: aksesoris tambahan (bando dll), Seserahan, Ring Box, order batal, barang hilang, dan barang yang belum kembali. Barang rusak yang kembali tetap dihitung.</p>
        {sd.lainnya_pcs > 0 && (
          <p data-testid="set-dicuci-lain">Di periode ini ada {sd.lainnya_pcs} pcs barang lain (aksesoris, seserahan, dll) yang kembali dan tidak dihitung sebagai set.</p>
        )}
        <p>Angka ini = barang yang tercatat lewat <i>Terima Pengembalian</i>. Cocokkan dengan catatan tim laundry; barang yang lupa diterima di aplikasi belum terhitung.</p>
      </div>
    </div>
  );
}
